<template>
    <div>
        <el-card shadow="never">
            <el-row slot="header">
                <el-col :span="16">
                    <el-radio-group size="small" v-model="practice">
                        <el-radio-button :label="1">按人员统计</el-radio-button>
                        <el-radio-button :label="2">按数据库统计</el-radio-button>
                    </el-radio-group>
                    <el-button size="small" @click="$router.go(-1)">返回</el-button>
                </el-col>
                <el-col :span="8">
                    <el-form size="small" :inline="true" :model="formInline">
                        <el-form-item>
                            <el-select v-model="formInline.year" placeholder="年份">
                                <el-option label="2019年" :value="2019"></el-option>
                                <el-option label="2018年" :value="2018"></el-option>
                                <el-option label="2017年" :value="2017"></el-option>
                                <el-option label="2016年" :value="2016"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="formInline.month" placeholder="月份">
                                <el-option label="1月" :value="1"></el-option>
                                <el-option label="2月" :value="2"></el-option>
                                <el-option label="3月" :value="3"></el-option>
                                <el-option label="4月" :value="4"></el-option>
                                <el-option label="5月" :value="5"></el-option>
                                <el-option label="6月" :value="6"></el-option>
                                <el-option label="7月" :value="7"></el-option>
                                <el-option label="8月" :value="8"></el-option>
                                <el-option label="9月" :value="9"></el-option>
                                <el-option label="10月" :value="10"></el-option>
                                <el-option label="11月" :value="11"></el-option>
                                <el-option label="12月" :value="12"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmit">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <div>
                <el-row>
                    <el-col :span="8">
                        <el-form ref="form" :model="form" label-width="80px">
                            <el-form-item label="作答量：">
                                <el-progress :percentage="100"></el-progress>
                            </el-form-item>
                            <el-form-item label="答对量：">
                                <el-progress :percentage="80"></el-progress>
                            </el-form-item>
                            <el-form-item label="正确率：">
                                <el-progress :percentage="60"></el-progress>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    data () {
        return {
            practice: 1,
            formInline: {},
            form: {}
        }
    },
    methods: {
        onSubmit () {}
    }
}
</script>